/* src/app/shared-components/add-methodology/add-methodology.component.scss */
/*# sourceMappingURL=add-methodology.component.css.map */
